import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementCheckVesDu } from '@api/networkElements';

import { extractQueryParams } from '@utils/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_CHECK_VES_DU } from '@constants/queryKeys';

interface IUseQueryNetworkElementCheckDuVesReturned {
	isAvailableVesDu: boolean;
	isLoadingCheckVesDu: boolean;
}

const useQueryNetworkElementCheckVesDu = (id?: string): IUseQueryNetworkElementCheckDuVesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_CHECK_VES_DU, id],
		queryFn: extractQueryParams(getNetworkElementCheckVesDu),
		enabled: [!!id],
		...refetchOptions,
	});

	return {
		isAvailableVesDu: data?.isAvailable || false,
		isLoadingCheckVesDu: isLoading || isFetching,
	};
};

export default useQueryNetworkElementCheckVesDu;
